import { Link } from "@tanstack/react-router";
import { useTranslation } from "@/context/TranslationContext";
import styles from "./Footer.module.scss";

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  const instagramUrl: string = "https://instagram.com/koricode_?igsh=dmlvZnVzZ3BqNQR0&ut-m_source=qr";
const redditUrl: string = "https://www.reddit.com/user/Acceptable-Snow3379/?utm_source=share&utm_medium=web3x&utm_name=web3xcss&utm_term=1&utm_content=share_button";

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerContent}>
          <div className={styles.footerSection}>
            <h3>KoriCode</h3>
            <p className={styles.tagline}>{t("FOOTER.TAGLINE")}</p>
          </div>

          <div className={styles.footerSection}>
            <h4>{t("FOOTER.NAVIGATION")}</h4>
            <ul>
              <li>
                <a href="#hero">{t("NAV.HOME")}</a>
              </li>
              <li>
                <a href="#about">{t("NAV.ABOUT")}</a>
              </li>
              <li>
                <a href="#skills">{t("NAV.SKILLS")}</a>
              </li>
              {/* <li>
                <a href="#projects">{t("NAV.PROJECTS")}</a>
              </li> */}
              <li>
                <a href="#contact">{t("NAV.CONTACT")}</a>
              </li>
            </ul>
          </div>

          <div className={styles.footerSection}>
            <h4>{t("FOOTER.SOCIAL")}</h4>
            <div className={styles.socialLinks}>
              <a
                href={instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <i className="bx bxl-instagram"></i>
              </a>
              <a 
                href={redditUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Reddit"
              >
                <i className="bx bxl-reddit"></i>
              </a>
            </div>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <div className={styles.footerBottomContent}>
            <p>
              &copy; {year} KoriCode. {t("FOOTER.RIGHTS")}
            </p>
            <div className={styles.legalLinks}>
              <Link to="/impressum">{t("FOOTER.LEGAL.IMPRESSUM")}</Link>
              <span>|</span>
              <Link to="/datenschutz">{t("FOOTER.LEGAL.PRIVACY")}</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
